import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-885c4a78"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "psContainer"
};
var _hoisted_2 = {
  class: "h-left"
};
var _hoisted_3 = {
  class: "top-bar"
};
var _hoisted_4 = {
  class: "tabs"
};
var _hoisted_5 = {
  class: "menu"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "name"
};
var _hoisted_9 = {
  class: "unfold"
};
var _hoisted_10 = {
  key: 0,
  class: "txt"
};
var _hoisted_11 = {
  key: 1,
  class: "txt"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  class: "txt-box"
};
var _hoisted_14 = {
  class: "name"
};
var _hoisted_15 = {
  class: "cell"
};
var _hoisted_16 = {
  class: "cell"
};
var _hoisted_17 = {
  key: 1
};
var _hoisted_18 = {
  class: "h-right"
};
import Center from './center';
import { ref } from 'vue';
import { Search, DocumentAdd, Reading, Delete } from '@element-plus/icons-vue';
import { isNull } from '@/utils/filter';
import AddBookDialog from '@/components/dialogs/addBookDialog.vue';
import { getPedigreeBookList, removeBook } from '@/api/book';
export default {
  setup: function setup(__props) {
    var dialogVisible = ref(false);
    var dialogTitle = ref('');
    var dialogTableValue = ref([]);
    var activeNames = ref(['1']);
    var selectedTab = ref(0);

    var handleDialogValue = function handleDialogValue(row) {
      if (isNull(row)) {
        dialogTitle.value = '创建谱书';
        dialogTableValue.value = {};
      } else {
        dialogTitle.value = '编辑谱书';
        dialogTableValue.value = JSON.parse(JSON.stringify(row));
      }

      dialogVisible.value = true;
    };

    var bookListData = ref([]);
    var bookData = ref({});

    var initBookList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPedigreeBookList();

              case 2:
                res = _context.sent;

                // 如果没有数据，就跳新建界面
                if (res === null || res.length === 0) {
                  handleDialogValue();
                } else {
                  res.forEach(function (item) {
                    item.on = false;
                    item.bookList.forEach(function (a) {
                      a.on = false;
                    });
                  });
                  bookListData.value = res;
                  activeNames.value = res[0].pedigreeName;
                  bookListData.value[0].on = true;
                  bookListData.value[0].bookList[0].on = true;
                  bookData.value = res[0].bookList[0];
                  bookData.value.pedigreeName = res[0].pedigreeName;
                  console.log(bookListData.value);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initBookList() {
        return _ref.apply(this, arguments);
      };
    }();

    initBookList();

    var handleSelectChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item, a) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                bookListData.value.forEach(function (item) {
                  item.bookList.forEach(function (a) {
                    a.on = false;
                  });
                });
                a.on = true;
                bookData.value = a;
                bookData.value.pedigreeName = item.pedigreeName;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handleSelectChange(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var handleRemoveBook = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = bookData.value.id;
                _context3.next = 3;
                return removeBook(id);

              case 3:
                initBookList();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function handleRemoveBook() {
        return _ref3.apply(this, arguments);
      };
    }();

    var handleOn = function handleOn(item) {
      var onStatus = item.on;

      if (onStatus) {
        item.on = false;
      } else {
        item.on = true;
      }
    };

    return function (_ctx, _cache) {
      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_input = _resolveComponent("el-input");

      var _component_Files = _resolveComponent("Files");

      var _component_ArrowDown = _resolveComponent("ArrowDown");

      var _component_Book = _resolveComponent("Book");

      var _component_el_collapse_transition = _resolveComponent("el-collapse-transition");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
        class: "item",
        effect: "light",
        content: "添加谱书",
        placement: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "icon",
            "render-header": "123",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return handleDialogValue();
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(DocumentAdd))];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        class: "item",
        effect: "light",
        content: "复制谱书",
        placement: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "icon",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.handleGroupDialogValue();
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(Reading))];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        class: "item",
        effect: "light",
        content: "删除",
        placement: "bottom"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            class: "icon",
            onClick: handleRemoveBook
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(Delete))];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createVNode(_component_el_input, {
        modelValue: _ctx.input2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.input2 = $event;
        }),
        class: "w-50 m-2",
        placeholder: "请输入要查找的内容",
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        class: _normalizeClass(["item", {
          on: selectedTab.value === 0
        }]),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return selectedTab.value = 0;
        })
      }, " 我的谱书 ", 2), _createElementVNode("span", {
        class: _normalizeClass(["item", {
          on: selectedTab.value === 1
        }]),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return selectedTab.value = 1;
        })
      }, " 范例库 ", 2)]), _createElementVNode("div", _hoisted_5, [selectedTab.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookListData.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id
        }, [_createElementVNode("div", {
          class: _normalizeClass(["file-title", {
            on: item.on
          }]),
          onClick: function onClick($event) {
            return handleOn(item);
          }
        }, [_createVNode(_component_el_icon, {
          class: "icon"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_Files)];
          }),
          _: 1
        }), _createElementVNode("span", _hoisted_8, _toDisplayString(item.pedigreeName), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
          class: _normalizeClass({
            arrow: item.on
          })
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_ArrowDown)];
          }),
          _: 2
        }, 1032, ["class"]), item.on ? (_openBlock(), _createElementBlock("span", _hoisted_10, "收起")) : (_openBlock(), _createElementBlock("span", _hoisted_11, "展开"))])], 10, _hoisted_7), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.bookList, function (a) {
          return _openBlock(), _createElementBlock("div", {
            class: "file-list",
            key: a.id
          }, [_createVNode(_component_el_collapse_transition, null, {
            default: _withCtx(function () {
              return [_withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["item", {
                  on: a.on
                }]),
                onClick: function onClick($event) {
                  return handleSelectChange(item, a);
                }
              }, [_createVNode(_component_Book, {
                class: "pic",
                scale: "transform: scale(0.68);",
                title: item.pedigreeName
              }, null, 8, ["title"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(a.name), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.pedigreeName), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(a.bookNumber), 1)])], 10, _hoisted_12), [[_vShow, item.on]])];
            }),
            _: 2
          }, 1024)]);
        }), 128))]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_17, "我是范例库"))])]), _createElementVNode("div", _hoisted_18, [_createVNode(_unref(Center), {
        data: bookData.value
      }, null, 8, ["data"])])]), dialogVisible.value ? (_openBlock(), _createBlock(AddBookDialog, {
        key: 0,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return dialogVisible.value = $event;
        }),
        dialogTitle: dialogTitle.value,
        onInitBookList: initBookList,
        dialogTableValue: dialogTableValue.value
      }, null, 8, ["modelValue", "dialogTitle", "dialogTableValue"])) : _createCommentVNode("", true)], 64);
    };
  }
};